"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserEvents = void 0;
class UserEvents {
    builder;
    constructor(builder) {
        this.builder = builder;
    }
    static user(builder) {
        return new UserEvents(builder);
    }
    addPart(part) {
        this.builder.addPart(part);
        return this;
    }
    toString() {
        return this.builder.toString();
    }
    get create() {
        return this.builder.addPart("create").toString();
    }
    get wildcard() {
        return this.builder.wildcard;
    }
}
exports.UserEvents = UserEvents;
